/**
 * Single source of truth for the public site URL. Used for canonicals, OG URLs,
 * breadcrumbs, and absolute asset URLs. Prefer sitePath() to build full URLs.
 */

/** Base URL of the site (no trailing slash). Use sitePath() for full URLs. */
export const SITE_URL: string =
  import.meta.env.VITE_SITE_URL?.trim() || 'https://padmora.com';

/**
 * Returns the full URL for a path. Ensures a single slash between base and path.
 * @param path - Path with or without leading slash (e.g. '/store' or 'store')
 */
export function sitePath(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL.replace(/\/$/, '')}${p}`;
}
